module.exports = __webpack_public_path__ + "img/yoplay.a25ec526.png";